import React from "react";
import moment from "moment";
const HRNumbers = require("approximate-number");
export const StandardPickerDateFormat = (Date) => {
  return moment(Date).format("MMMM DD, YYYY");
};

export const fullDateFormat = (date) => {
  return (
    <>
      {moment(date).format("MMMM DD, YYYY")}
      <br />
      <small>{moment(date).format("h:mm a")}</small>
    </>
  );
};

export const dateOnlyFormat = (date) => {
  return (
    <>
      {moment(date).format("D MMM YYYY")}
    </>
  );
};

export const dateFormat = (date) => {
  return (
    <>
      {moment(date).format("D MMM YYYY")}
      {/* <br /> */}
      <small>({moment(date).format("h:mm a")})</small>
    </>
  );
};

export const downloadFile = (dataurl, filename) => {
  const a = document.createElement("a");
  a.href = dataurl;
  a.setAttribute("download", filename);
  a.click();
};

export const monthDayYearFormat = (date) => {
  return <>{moment(date).format("MMMM DD, YYYY")}</>;
};

export default function appendData(values) {
  console.log(values, "<-------- values")
  const formValues = { ...values };
  const formData = new FormData();
  for (const value in formValues) {
    formData.append(value, formValues[value]);
  }
  return formData;
}
export function appendMultiStepData(values) {
  console.log(values, "<-------- values")
  const formValues = { ...values };
  const formData = new FormData();
  for (const value in formValues) {
    if(Array.isArray(formValues[value])){
      let valueArr = formValues[value];
      for (const val in valueArr) {
        console.log(value, valueArr[val], "<------")
        formData.append(value, valueArr[val]);
      }

    }else{
      formData.append(value, formValues[value]);
    }
  }

  console.log(formData, "<<--------- form data");
  return formData;
}

export const humanReadableNumber = (number) => {
  return HRNumbers(number, { capital: true });
};

export const walletAddressShort = (string) => {
  return string
    ? string.slice(0, 5) + "..." + string.slice(string.length - 5)
    : "";
};

export const dateStringToDate = (timestamp) => {
  const date = moment.unix(timestamp).format("DD MMM, YYYY");
  return date;
};

export const firstLetterCapital = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

